"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    Breadcrumbs: {
      backgroundColor: theme['$breadcrumb-background-color'],
      display: 'flex',
      padding: '10px 20px'
    },
    Link: {
      flexGrow: 0,
      fontFamily: theme['$font-heading'],
      fontWeight: 'bold',
      '& + *': {
        marginLeft: '5px',
        '&:before': {
          content: '\'//\'',
          marginRight: '5px',
          color: theme['$breadcrumb-link-border-color'],
          display: 'inline-block'
        }
      }
    },
    NavBackArrow: {
      flexGrow: 0,
      color: theme['$breadcrumb-icon-color'],
      height: '20px !important',
      width: '20px !important'
    },
    PageBackArrow: {
      flexGrow: 0,
      color: theme['$breadcrumb-icon-color'],
      height: '17px !important',
      width: '17px !important'
    },
    NavBreadcrumbs: {
      '& a': {
        fontFamily: theme['$font-heading'],
        fontSize: 14,
        fontWeight: 700
      },
      lineHeight: '19px'
    },
    PageBreadcrumbs: {
      lineHeight: '16px'
    },
    Disabled: {
      color: theme['$text-color'],
      '&:hover': {
        color: theme['$text-color']
      }
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map